import { Fragment, useRef } from "react"

import useScrollTo from "../../../../hooks/use-scroll-to"
import PlanImage from "../../components/plan-image"
import SubmitButton from "../../components/submit-button"

import RecommendedLabel from "./recommended-label"
import SinglePurchaseVariant from "./single-purchase-variant"
import SubscriptionPlanOverview from "./subscription-plan-overview"
import SubscriptionVariant from "./subscription-variant"

const Plan = ({ plan, selectedPlanId, onSelect, onSubmit, className }) => {
  const { title, details, image, isSubscription } = plan.variants[0]
  const planRef = useRef(null)
  const { scrollTo } = useScrollTo()

  const handleClick = (plan) => {
    onSelect(plan.id)
    scrollTo({ target: planRef.current })
  }

  const dataTestIdPrefix = isSubscription ? "auto-refill" : title.toLowerCase()

  return (
    <div
      ref={planRef}
      data-testid={`web-portal-plan-selection-${dataTestIdPrefix}-plan-block`}
      data-component-name="Plan"
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 4,
        background: "background",
        borderRadius: "8px",
        position: "relative",
        "& + div": {
          mt: [4, 0],
        },
      }}
      className={className}
    >
      {plan.group && (
        <Fragment>
          <SubscriptionPlanOverview
            title="Auto-Refill"
            subTitle="Unser Rundum-sorglos-Paket"
            details={details}
          />

          <PlanImage
            image={image}
            title={title}
            sx={{ display: ["none", "block"] }}
          />

          <div
            sx={{
              display: ["none", "block"],
              position: "absolute",
              top: 0,
              right: 5,
              transform: "translateY(-50%)",
            }}
          >
            {" "}
            <RecommendedLabel />
          </div>
        </Fragment>
      )}

      {plan.variants.map((variant) =>
        variant.isSubscription ? (
          <SubscriptionVariant
            key={variant.id}
            variant={variant}
            isSelected={variant.id === selectedPlanId}
            onClick={() => handleClick(variant)}
          />
        ) : (
          <SinglePurchaseVariant
            key={variant.id}
            variant={variant}
            isSelected={variant.id === selectedPlanId}
            onClick={() => handleClick(variant)}
          />
        )
      )}

      <SubmitButton
        data-testid="web-portal-plan-selection-desktop-btn"
        sx={{ display: ["none", "inline-flex"], mt: "auto" }}
        onClick={() => {
          if (plan.group) {
            const isSelectedPlanSubscription = plan.variants.find(
              (v) => v.id === selectedPlanId
            )
            const id = isSelectedPlanSubscription
              ? selectedPlanId
              : plan.variants[0].id
            onSubmit(id)
            return
          }

          // since we don't have the radio button for single purchase and rezept on the desktop
          // we select the first variant
          onSubmit(plan.variants[0].id)
        }}
      >
        Weiter
      </SubmitButton>
    </div>
  )
}

export default Plan
